import Player, { getGlobalAudio } from "./Player.js";
import NowPlaying from "./NowPlaying";
import ChatDialog from "./ChatDialog.js";
import React, { useState, Suspense, useRef, useEffect, useContext } from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom'

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
// import LineIcon from "react-lineicons";
import CircularProgress from '@mui/material/CircularProgress';
// import HomeIcon from './img/house-solid.svg';
// import VideoIcon from './img/video-solid.svg';
// import MicrophoneIcon from './img/microphone-solid.svg';
// import ListIcon from './img/list-solid.svg';
// import CalendarIcon from './img/calendar-days-solid.svg';
// import LinkIcon from './img/link-solid.svg';
// import FacebookIcon from './img/facebook-f.svg';
// import TwitterIcon from './img/twitter.svg';
// import AppleIcon from './img/apple.svg';
// import AndroidIcon from './img/android.svg';
// import CloseIcon from './img/xmark-solid.svg';
// import BarsIcon from './img/bars-solid.svg';
import { BsHouse, BsCameraVideo, BsMic, BsListUl, BsList, BsCalendar, BsLink } from "react-icons/bs";
import { AiOutlineClose, AiOutlineFacebook, AiOutlineApple, AiOutlineAndroid } from "react-icons/ai";
import { FaXTwitter } from 'react-icons/fa6';
import { VideoPlayerProvider, VideoPlayerContext } from './VideoPlayerContext';
import './Player.css';
import GlobalVideoPlayer from './GlobalVideoPlayer';


const Home = React.lazy(() => import('./Home.js'));
const DJlist = React.lazy(() => import('./DJlist.js'));
const Shows = React.lazy(() => import('./Shows.js'));
const VisualRadio = React.lazy(() => import('./VisualRadio.js'));
const Playlist = React.lazy(() => import('./Playlist.js'));
const SinglePostCheck = React.lazy(() => import('./SinglePostCheck.js'));
const DJpage = React.lazy(() => import('./DJpage.js'));
const Partners = React.lazy(() => import('./Partners.js'));
const NowOnAir =  React.lazy(() => import('./NowOnAir.js'));

const VolumeSlider = () => {
  const [volume, setVolume] = useState(1);
  const { playerRef } = useContext(VideoPlayerContext);

  useEffect(() => {
    const audio = getGlobalAudio();
    if (audio) {
      audio.volume = volume;
    }
    if (playerRef.current) {
      playerRef.current.volume(volume);
    }
  }, [volume]);

  return (
    <input
      type="range"
      min="0"
      max="1"
      step="0.01"
      value={volume}
      onChange={(e) => setVolume(parseFloat(e.target.value))}
      className="volume-slider"
      style={{
        width: '100px',
        cursor: 'pointer',
        background: `linear-gradient(to right, rgb(255, 44, 94) 0%, rgb(255, 44, 94) ${volume * 100}%, #ddd ${volume * 100}%, #ddd 100%)`,
        height: '6px',
        borderRadius: '3px',
        WebkitAppearance: 'none',
        appearance: 'none'
      }}
    />
  );
};

const VisualRadioMenuLink = ({ children, style }) => {
  const { playerRef, setIsClosed } = useContext(VideoPlayerContext);

  const handleClick = () => {
    setIsClosed(false);

    if (playerRef.current) {
      playerRef.current.muted(false);
      const playPromise = playerRef.current.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch((error) => console.error('Visual Radio autostart blocked', error));
      }
    }
  };

  return (
    <Link to="/visual-radio" onClick={handleClick} style={style}>
      {children}
    </Link>
  );
};


const App = () => {

  const [navbarOpen, setNavbarOpen] = useState(false)


  const handleToggle = () => {
    setNavbarOpen(prev => !prev)
  }


  const loadInstagramEmbed = () => {
    const script = document.createElement("script");

    script.src = "https://www.instagram.com/static/bundles/es6/EmbedSDK.js/ab12745d93c5.js";
    script.defer = true;

    document.body.appendChild(script);
  

    script.addEventListener('load', () => {
    });

  }

  loadInstagramEmbed();
  

  return (
    <VideoPlayerProvider>
    <div className="App">
      <GlobalVideoPlayer />

      <Router>
      <div className="on-air-holder">
      <Link to="/"><img src="https://megahitlive.s3.eu-central-1.amazonaws.com/wp-content/uploads/2024/10/mhwebp-2.webp" width="80" height="80" style={{paddingLeft: 70, position: 'relative', float: 'left'}} /></Link>
<Suspense fallback={<div style={{display: 'flex',  justifyContent:'center', alignItems:'center', height: '100vh'}}><CircularProgress /></div>}>
      <NowOnAir />
      </Suspense>
      </div>

      <div className={`menuNav ${navbarOpen ? " showMenu" : ""}`}>
      <Suspense fallback={<div style={{display: 'flex',  justifyContent:'center', alignItems:'center', height: '100vh'}}><CircularProgress /></div>}>
      <List className="mobileNavItems">
      <div onClick={handleToggle} className="closeToggle"><AiOutlineClose alt="Close" fontSize={20} style={{marginRight: 15, marginBottom: -3}}/></div>
      <div className="menuInner">
      <ListItem>
      <Link to="/home" style={{fontSize: 14, marginBottom: 10}}><BsHouse alt="Home" fontSize={20} style={{marginRight: 15, marginBottom: -3}} />Home</Link>
      </ListItem>
      <ListItem>
      <VisualRadioMenuLink style={{fontSize: 14, marginBottom: 10}}><BsCameraVideo alt="Visual Radio" fontSize={20} style={{marginRight: 15, marginBottom: -3}} />Visual Radio</VisualRadioMenuLink>
      </ListItem>
      <ListItem>
      <Link to="/DJs" style={{fontSize: 14, marginBottom: 10}}><BsMic alt="DJs" fontSize={20} style={{marginRight: 15, marginBottom: -3}}/>DJs</Link>
      </ListItem>
      <ListItem>
      <Link to="/playlist" style={{fontSize: 14, marginBottom: 10}}><BsListUl alt="Playlist" fontSize={20} style={{marginRight: 15, marginBottom: -3}}/>Playlist</Link>
      </ListItem>
      <ListItem>
      <Link to="/uitzendingen" style={{fontSize: 14, marginBottom: 10}}><BsCalendar alt="Uitzendingen" fontSize={18} style={{marginRight: 15, marginBottom: -3}}/>Uitzendingen</Link>
      </ListItem>
      <ListItem>
      <Link to="/partners" style={{fontSize: 14, marginBottom: 10}}><BsLink alt="Partners" fontSize={20} style={{marginRight: 15, marginBottom: -3}}/>Partners</Link>
      </ListItem>
      <ListItem>
      <a href="https://facebook.com/wearemegahit" target="_blank" style={{fontSize: 14, marginBottom: 10}}><AiOutlineFacebook alt="Facebook" fontSize={20} style={{marginRight: 15, marginBottom: -3}}/>Facebook</a>
      </ListItem>
      <ListItem>
      <a href="https://x.com/megahitlive" target="_blank" style={{fontSize: 14, marginBottom: 10}}><FaXTwitter alt="Twitter" fontSize={20} style={{marginRight: 15, marginBottom: -3}}/>X</a>
      </ListItem>
      <ListItem>
      <a href="https://apps.apple.com/app/id1518632994" target="_blank" style={{fontSize: 14, marginBottom: 10}}><AiOutlineApple alt="iOS" fontSize={20} style={{marginRight: 15, marginBottom: -3}}/>MegaHit voor iOS</a>
      </ListItem>
      <ListItem>
      <a href="https://play.google.com/store/apps/details?id=com.megahit" target="_blank" style={{fontSize: 14}}><AiOutlineAndroid alt="iOS" fontSize={20} style={{marginRight: 15, marginBottom: -3}}/>MegaHit voor Android</a>
      </ListItem>
      </div>
      </List>
      </Suspense>


      </div>
      <div className="nav1">
        
      <Suspense fallback={<div style={{display: 'flex',  justifyContent:'center', alignItems:'center', height: '100vh'}}><CircularProgress /></div>}>
        <div className="mobilenav">
        <Link to="/"><img src="https://megahitlive.s3.eu-central-1.amazonaws.com/wp-content/uploads/2024/10/mhwebp-2.webp" width="80" height="80" style={{paddingLeft: 10, position: 'relative', float: 'left'}} /></Link>
        <NowOnAir />
        <div onClick={handleToggle} className="mobile-toggle"><BsList alt="Home" fontSize={20} style={{marginRight: 15, marginTop: 20}} /></div>
      </div>
      </Suspense>


        <List className="nav-items">
        <Suspense fallback={<div style={{display: 'flex',  justifyContent:'center', alignItems:'center', height: '100vh'}}><CircularProgress /></div>}>
      <ListItem className="hover-icon" style={{marginTop: 10}}>
      <Link to="/home" style={{fontSize: 14}}><BsHouse alt="Home" fontSize={20} style={{marginBottom: -3, color: 'white'}} /></Link>
      </ListItem>
      <ListItem className="hover-icon" style={{marginTop: 10}}>
      <VisualRadioMenuLink style={{fontSize: 14}}><BsCameraVideo alt="Visual Radio" fontSize={20} style={{marginBottom: -3, color: 'white'}} /></VisualRadioMenuLink>
      </ListItem>
      <ListItem className="hover-icon" style={{marginTop: 10}}>
      <Link to="/DJs" style={{fontSize: 14}}><BsMic alt="DJs" fontSize={20} style={{marginBottom: -3, color: 'white'}}/></Link>
      </ListItem>
      <ListItem className="hover-icon" style={{marginTop: 10}}>
      <Link to="/playlist" style={{fontSize: 14}}><BsListUl alt="Playlist" fontSize={20} style={{marginBottom: -3, color: 'white'}}/></Link>
      </ListItem>
      <ListItem className="hover-icon" style={{marginTop: 10}}>
      <Link to="/uitzendingen" style={{fontSize: 14}}><BsCalendar alt="Uitzendingen" fontSize={18} style={{marginBottom: -3, color: 'white'}}/></Link>
      </ListItem>
      <ListItem className="hover-icon" style={{marginTop: 10}}>
      <Link to="/partners" style={{fontSize: 14}}><BsLink alt="Partners" fontSize={20} style={{marginBottom: -3, color: 'white'}}/></Link>
      </ListItem>
      <ListItem className="hover-icon" style={{marginTop: 10}}>
      <a href="https://facebook.com/wearemegahit" target="_blank" style={{fontSize: 14}}><AiOutlineFacebook alt="Facebook" fontSize={20} style={{marginBottom: -3, color: 'white'}}/></a>
      </ListItem>
      <ListItem className="hover-icon" style={{marginTop: 10}}>
      <a href="https://twitter.com/megahitlive" target="_blank" style={{fontSize: 14}}><FaXTwitter alt="Twitter" fontSize={20} style={{marginBottom: -3, color: 'white'}}/></a>
      </ListItem>
      <ListItem className="hover-icon" style={{marginTop: 10}}>
      <a href="https://apps.apple.com/app/id1518632994" target="_blank" style={{fontSize: 14}}><AiOutlineApple alt="iOS" fontSize={20} style={{marginBottom: -3, color: 'white'}}/></a>
      </ListItem>
      <ListItem className="hover-icon" style={{marginTop: 10}}>
      <a href="https://play.google.com/store/apps/details?id=com.megahit" target="_blank" style={{fontSize: 14}}><AiOutlineAndroid alt="iOS" fontSize={20} style={{marginBottom: -3, color: 'white'}}/></a>
      </ListItem>

      </Suspense>
      </List>
      </div>
      
      <div className="view">

        <Suspense fallback={<div style={{display: 'flex',  justifyContent:'center', alignItems:'center', height: '100vh'}}><CircularProgress /></div>}>
        <Routes>

          <Route exact path="/uitzendingen" element={<Shows />}/>
          <Route exact path="/react" element={<Home />}/>
          <Route exact path="/DJs" element={<DJlist/>}/>
          <Route exact path="/uitzendingen" element={<Shows/>}/>
          <Route exact path="/visual-radio" element={<VisualRadio/>}/>
          <Route exact path="/playlist" element={<Playlist />}/>
          <Route path="/hotnews/:slug" element={<SinglePostCheck />}/>
          <Route path="/newmusic/:slug" element={<SinglePostCheck />}/>
          <Route exact path="/partners" element={<Partners slug="partners" />}/>
          <Route path="/djs/:slug" element={<DJpage />}/>

          <Route path="*" element={<Home />}/>
        </Routes>
        </Suspense>


      </div>
      <div className="player">
      <div className="player_inner"><Player url="https://air.broadcastinggroup.ro/MegaHit" /></div>
      <Suspense fallback={<div style={{display: 'flex',  justifyContent:'center', alignItems:'center', height: '100vh'}}><CircularProgress /></div>}>
       <NowPlaying />
      </Suspense>
      <div className="player_volume">
        <VolumeSlider />
      </div>

      </div>
      <ChatDialog />
      </Router>

    </div>
    </VideoPlayerProvider>
  );
}

export default App;
